import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import HTMLReactParser from 'html-react-parser'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux'
import { FlexContainer, Paragraph, device } from 'heliocor-ui';
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Checkbox, makeStyles } from '@material-ui/core';

import { SET_TERMS_ACCEPTANCE } from '../../store/cafe/actionTypes'

import { WarningBox } from '../../common/WarningBox';


const useStyles = makeStyles({
    root: {
        padding: 0,
    },
})

const ParagraphTerms = styled(Paragraph)`
    margin: 0;
    width: 12rem;
    @media ${device.midSize}{
        width: 25rem;
    }
`

const TermsAndConditions = () => {

    const classes = useStyles()
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const [openTerms, setOpenTerms] = useState(false)

    const terms = useSelector(state => state.settings.termsAndConditions)
    const termsAccepted = useSelector(state => state.config.termsAccepted)

    const setTermsAcceptance = useCallback(() => dispatch({ type: SET_TERMS_ACCEPTANCE, accepted: !termsAccepted }), [dispatch, termsAccepted])

    const handleTermsAcceptance = () => {
        setOpenTerms(!openTerms)
        setTermsAcceptance()
    }


    return !terms ? null :
        <FlexContainer justifyContent='center' alignItems='center' padding="2rem">
            <ParagraphTerms>
                {t('agreeEditable')}
                <span onClick={() => setOpenTerms(!openTerms)}>
                    <strong style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                        {t('termsAndConditions')}
                    </strong>
                </span>
            </ParagraphTerms>
            <FormControlLabel
                control={
                    <Checkbox
                        data-cy="terms-checkbox"
                        color='primary'
                        checked={termsAccepted}
                        onClick={setTermsAcceptance}
                        className={classes.root}
                    /> 
                }
                style={{  width: '3rem' }}
                labelPlacement="start"
            />
            <WarningBox
                open={openTerms}
                title={'termsAndConditions'}
                onClose={() => setOpenTerms(!openTerms)}
                content={<div className='html-parser'>{HTMLReactParser(terms)}</div>}
                buttons={!termsAccepted && [{
                    value: t('button.accept'),
                    onClick: handleTermsAcceptance
                }]}
            />
        </FlexContainer>
}


export default TermsAndConditions